export default __webpack_public_path__ + "static/media/264.e2487ae1.png";